import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'addTitleToProductType'
})
export class AddTitleToProductType implements PipeTransform {
    transform(productTypes: any[]) {
        return productTypes.map((productType: any) => {
            productType.translations.forEach((data: any) => {
              if(data.language.code === 'EN'){
                productType.title = data.title;
                return 
              }
            })
            return productType
          }); 
    }
}